import { type api } from 'common';

import { type PermissionRequirement, type RoleRequirement } from './types';

export function isPermissionAuthorized(
  permissions: api.Group.Permission[],
  permissionRequirement: PermissionRequirement
) {
  if (typeof permissionRequirement === 'object' && 'or' in permissionRequirement) {
    return permissions.some((permission) => permissionRequirement.or.includes(permission));
  }
  if (typeof permissionRequirement === 'object' && 'and' in permissionRequirement) {
    return permissionRequirement.and.every((permission) => permissions.includes(permission));
  }
  return permissions.includes(permissionRequirement);
}

export function isRoleAuthorized(role: api.User.Role, roleRequirement: RoleRequirement) {
  if (Array.isArray(roleRequirement)) {
    return roleRequirement.includes(role);
  }
  return role === roleRequirement;
}
